import React, { type FC } from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import GenericErrorIllustration from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/generic-error/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const ErrorDisplay: FC<{ refetch: () => void }> = ({ refetch }) => {
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			header={formatMessage(messages.errorDisplayHeading)}
			description={formatMessage(messages.errorDisplayDescription)}
			renderImage={getAkEmptyStateRenderImageFn(GenericErrorIllustration)}
			imageWidth={160}
			maxImageHeight={220}
			primaryAction={
				<Button onClick={refetch} appearance="link">
					{formatMessage(messages.reloadNowButtonText)}
				</Button>
			}
		/>
	);
};
